import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, FormArray, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserService } from '../../../../../services/user.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoadingService } from '../../../../../services/loading.service';
import { ToastModule } from 'primeng/toast';
import { DividerModule } from 'primeng/divider';
import { PanelModule } from 'primeng/panel';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CommonModule, JsonPipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { CustomMessages } from '../../../../../interfaces/custom-response.model';


@Component({
  selector: 'app-user-edit',
  standalone: true,
  imports: [ToastModule, DividerModule, PanelModule, DropdownModule, ButtonModule, TableModule, InputTextModule, SelectButtonModule,
    ReactiveFormsModule, JsonPipe, CommonModule],

  templateUrl: './user-edit.component.html',
  styleUrl: './user-edit.component.css',
  providers: [MessageService]
})
export class UserEditComponent {

  userService = inject(UserService);
  dialogConfig = inject(DynamicDialogConfig);
  loadingService = inject(LoadingService);
  messageService = inject(MessageService);
  router = inject(Router);
  fb = inject(FormBuilder);

  ref = inject(DynamicDialogRef);

  userid: string = "";
  loading: boolean = false;

  errorMessages: CustomMessages = {};

  user: any = {};

  adminOptions: any[] = [{ label: "Benutzer", value: "N" }, { label: "Administrator", value: "Y" }];

  userEditForm = this.fb.group({
    usersid: [''],
    firstname: ['', Validators.required],
    lastname: ['', Validators.required],
    email: ['', Validators.required],
    is_administrator: ['N', Validators.required],
    default_theme: [''],
    niederlassung_id: [''],
    password: [''],
    password_confirmation : ['']
  });

  passwordForm = this.fb.group({
    password: ['', Validators.required],
    password_confirmation: ['', Validators.required]
  });

  /*
    "usersid": "e71073c9-8635-4320-8ff5-7dbcea4568b0",
                "firstname": "andere",
                "lastname": null,
                "email": "andere@bettenstar.de",
                "deletable": 1,
                "is_administrator": "N"
  */

  constructor() {

    if (this.dialogConfig.data.userid) {
      this.userid = this.dialogConfig.data.userid;
    }
  }

  setupForm() {
    this.userEditForm = this.fb.group({
      usersid: [this.user.usersid],
      firstname: [this.user.firstname, Validators.required],
      lastname: [this.user.lastname, Validators.required],
      email: [this.user.email, Validators.required],
      is_administrator: [this.user.is_administrator, Validators.required],
      default_theme: [''],
      niederlassung_id: [this.user.niederlassung_id],
      password: [''],
      password_confirmation : ['']
    });
  }

  ngOnInit(): void {
    this.loading = true;
    this.loadingService.addCounter();

    this.user = this.dialogConfig.data.user;

    this.setupForm()

    this.loading = false;
    this.loadingService.removeCounter();

  }

  updateUser() {
    if (this.userEditForm.valid) {
      // this.loading = true;
      this.loadingService.addCounter();

      if (this.userEditForm.value.usersid == "") {
        this.userService.addUser(this.userEditForm.value).subscribe({
          next: (data) => {
            if (data.success == 1) {
              this.messageService.add({ key: 'tc', severity: 'success', summary: data.message });
              this.ref.close("created");
            }
            else {
              this.messageService.add({ key: 'tc', severity: 'error', summary: data.message });
              this.errorMessages = data.messages ?? {};
              console.log(this.errorMessages);
            }

            // this.loading = false;
            this.loadingService.removeCounter();
          },
          error: (error) => {
            if (error.status == 401) {
              console.log("Fehler! Auf zum Login!")
              this.loadingService.removeCounter();
              this.ref.close();
              this.router.navigateByUrl("/logout");
            }
          }
        }
        );
      } else {

        this.userService.updateUser(this.userEditForm.value).subscribe({
          next: (data) => {
            if (data.success == 1) {
              this.messageService.add({ key: 'tc', severity: 'success', summary: data.message });
              this.ref.close("updated");
            }
            else {
              this.messageService.add({ key: 'tc', severity: 'error', summary: data.message });
              this.errorMessages = data.messages ?? {};
              console.log(this.errorMessages);
            }

            // this.loading = false;
            this.loadingService.removeCounter();
          },
          error: (error) => {
            if (error.status == 401) {
              console.log("Fehler! Auf zum Login!")
              this.loadingService.removeCounter();
              this.ref.close();
              this.router.navigateByUrl("/logout");
            }
          }
        }
        );
      }
    }
  }

  savePassword() {
    console.log(this.passwordForm.value)

    if (this.passwordForm.valid) {
      this.loadingService.addCounter();

      this.userService.changePassword(this.userEditForm.value.usersid ?? "", this.passwordForm.value).subscribe({
        next: (data) => {
          if (data.success == 1) {
            this.messageService.add({ key: 'tc', severity: 'success', summary: data.message });
            this.ref.close("updated");
          }
          else {
            this.messageService.add({ key: 'tc', severity: 'error', summary: data.message });
            this.errorMessages = data.messages ?? {};
            console.log(this.errorMessages);
          }

          // this.loading = false;
          this.loadingService.removeCounter();
        },
        error: (error) => {
          if (error.status == 401) {
            console.log("Fehler! Auf zum Login!")
            this.loadingService.removeCounter();
            this.ref.close();
            this.router.navigateByUrl("/logout");
          }
        }
      }
      );
    }
  }


}
